import { GridApi } from 'ag-grid-community';
import { useEffect } from 'react';

interface UseCustomAgGridNavigationProps {
    api: GridApi | null;
    tableWrapperRef: React.RefObject<HTMLDivElement | null>;
}

export function useCustomAgGridNavigation({ api, tableWrapperRef }: UseCustomAgGridNavigationProps) {
    useEffect(() => {
        const handleKeyboardEvent = (event: KeyboardEvent) => {
            // Only act on keyboard events if the table is focused
            if (!tableWrapperRef.current?.contains(event.target as Node)) return;
            const key = event.key;
            const selectedRow = api?.getSelectedNodes()[0];
            const displayedRowCount = api?.getDisplayedRowCount() ?? 0;

            // Default to first row if no row is selected
            let nextIndex = 0;

            // Ensure node is selected and has a valid rowIndex, otherwise use the first row
            if (selectedRow && typeof selectedRow.rowIndex === 'number') {
                nextIndex = selectedRow.rowIndex;
                if (key === 'ArrowDown') {
                    nextIndex++;
                } else if (key === 'ArrowUp') {
                    nextIndex--;
                }
            }
            if (nextIndex >= 0 && nextIndex < displayedRowCount) {
                const nextNode = api?.getDisplayedRowAtIndex(nextIndex);
                if (nextNode) {
                    nextNode.setSelected(true);
                    api?.ensureIndexVisible(nextIndex);
                }
            }
        };

        document.addEventListener('keydown', handleKeyboardEvent);

        return () => {
            document.removeEventListener('keydown', handleKeyboardEvent);
        };
    }, [api, tableWrapperRef]);
}
